export const popupKey = "postJobPopup";

export const saveObjToStroage = (objToSave, key = popupKey) => {
  sessionStorage.setItem(key, JSON.stringify(objToSave));
}

export const clearSavedObj = () => {
  sessionStorage.removeItem(popupKey);
}
